import request from '@/utils/request'

// 获取所有的权限树
export function getPermissionTree(params) {
  return request({
    url: '/menu/tree',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/menu',
    method: 'post',
    data
  })
}

export function del(id) {
  return request({
    url: '/menu/' + id,
    method: 'delete'
  })
}

export function edit(data) {
  return request({
    url: '/menu',
    method: 'put',
    data
  })
}
